import React, { forwardRef } from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  toolbar: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: theme.spacing(1.25)
  },
  toolbarItemsContainer: {
    display: "flex",
    columnGap: theme.spacing(1.25),
    [theme.breakpoints.down("sm")]: {
      columnGap: 0
    }
  },
  toolbarItemsContainerPrimary: {
    width: "100%"
  },
  toolbarItems: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.25)
  },
  toolbarItemsPrimary: {
    width: "100%"
  },
  toolbarItemsSecondary: {
    marginLeft: "auto"
  },
  toolbarItemsStretched: {
    flex: 1
  }
}));
function Toolbar({ children }) {
  const { classes } = useClasses();
  return children ? /* @__PURE__ */ React.createElement(Box, { className: classes.toolbar }, children) : null;
}
function ToolbarItemsContainer({ primary = false, children }) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(Box, { className: cx(classes.toolbarItemsContainer, primary && classes.toolbarItemsContainerPrimary) }, children);
}
const ToolbarItems = forwardRef(
  ({ primary = false, secondary = false, streched = false, children }, ref) => {
    const { classes, cx } = useClasses();
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        className: cx(
          classes.toolbarItems,
          primary && classes.toolbarItemsPrimary,
          streched && classes.toolbarItemsStretched,
          secondary && classes.toolbarItemsSecondary
        ),
        ref
      },
      children
    );
  }
);
export {
  Toolbar,
  ToolbarItems,
  ToolbarItemsContainer
};
//# sourceMappingURL=Toolbar.js.map
